import api from "../api";

// Mock data for guardians after deadline
const getMockGuardianById = (id) => {
  const mockGuardians = {
    1: {
      id: 1,
      unique_guardian_number: "GG001234",
      gender: "Male",
      date_of_birth: "1990-05-15",
      national_insurance_number: "AB123456C",
      criminal_record: 0,
      medical_condition: 0,
      on_newsletter_list: 1,
      on_voluntary_work_list: 0,
      notes: "Reliable guardian with good references",
      status_id: 5,
      created_at: "2024-01-15T10:30:00.000Z",
      updated_at: "2024-01-20T14:45:00.000Z",
      user: {
        id: 1,
        first_name: "John",
        last_name: "Doe",
        email: "john.doe@example.com",
        phone_number: "+44123456789",
        mobile_number: "+447123456789",
        address_1: "123 Main Street",
        address_2: "Apartment 4B",
        address_3: "",
        town: "London",
        postcode: "SW1A 1AA",
        salutation: "Mr",
        job_title: "Software Developer",
      },
      status: {
        id: 5,
        name: "Documents Required",
        color: "#ffc107",
        order: 2,
        description: "Guardian needs to send documentation",
      },
      country: {
        id: 1,
        name: "United Kingdom",
        en_short_name: "UK",
      },
      religion: {
        id: 1,
        name: "Christianity",
      },
      hearAbout: {
        id: 1,
        name: "Friend / Family Member",
      },
      rents: [
        {
          id: 1,
          date_start: "2024-02-01T00:00:00.000Z",
          date_end: "2025-02-01T00:00:00.000Z",
          date_to_send_documentation: "2024-01-15T00:00:00.000Z",
          status: "active",
          room: {
            id: 1,
            name: "Room 1",
            price: 800,
            property: {
              id: 1,
              name: "44 Plummer Road",
              address_1: "44 Plummer Road",
              address_2: "",
              town: "London",
              postcode: "SW1A 1AA",
            },
          },
        },
      ],
      queries: [],
    },
    2: {
      id: 2,
      unique_guardian_number: "GG001235",
      gender: "Female",
      date_of_birth: "1988-12-03",
      national_insurance_number: "CD789012E",
      criminal_record: 0,
      medical_condition: 0,
      on_newsletter_list: 1,
      on_voluntary_work_list: 1,
      notes: "Experienced guardian with excellent track record",
      status_id: 6,
      created_at: "2024-01-10T09:15:00.000Z",
      updated_at: "2024-01-18T16:20:00.000Z",
      user: {
        id: 2,
        first_name: "Jane",
        last_name: "Smith",
        email: "jane.smith@example.com",
        phone_number: "+44123456790",
        mobile_number: "+447123456790",
        address_1: "456 Oak Avenue",
        address_2: "",
        address_3: "",
        town: "Manchester",
        postcode: "M1 1AA",
        salutation: "Ms",
        job_title: "Marketing Manager",
      },
      status: {
        id: 6,
        name: "Placed",
        color: "#28a745",
        order: 6,
        description: "Guardian lives in the property",
      },
      country: {
        id: 1,
        name: "United Kingdom",
        en_short_name: "UK",
      },
      religion: {
        id: 2,
        name: "Atheism",
      },
      hearAbout: {
        id: 2,
        name: "Google",
      },
      rents: [
        {
          id: 2,
          date_start: "2024-01-20T00:00:00.000Z",
          date_end: "2025-01-20T00:00:00.000Z",
          date_to_send_documentation: "2024-01-10T00:00:00.000Z",
          status: "active",
          room: {
            id: 2,
            name: "Room 2",
            price: 750,
            property: {
              id: 2,
              name: "18 White House",
              address_1: "18 White House",
              address_2: "",
              town: "Manchester",
              postcode: "M1 1AA",
            },
          },
        },
      ],
      queries: [],
    },
  };

  return mockGuardians[id] || mockGuardians[1]; // Default to guardian 1 if ID not found
};

const getMockAfterDeadlineGuardians = () => {
  return [
    {
      id: 1,
      unique_guardian_number: "GG001234",
      user: {
        id: 1,
        first_name: "John",
        last_name: "Doe",
        email: "john.doe@example.com",
        phone_number: "+44123456789",
        address_1: "123 Main Street",
        town: "London",
        postcode: "SW1A 1AA",
      },
      status: {
        id: 2,
        name: "Documents Required",
        color: "#ffc107",
      },
      status_id: 2,
      rents: [
        {
          id: 1,
          date_to_send_documentation: "2024-01-15T00:00:00.000Z",
          room: {
            id: 1,
            name: "Room 1",
            property: {
              id: 1,
              name: "44 Plummer Road",
            },
          },
        },
      ],
    },
    {
      id: 2,
      unique_guardian_number: "GG001235",
      user: {
        id: 2,
        first_name: "Jane",
        last_name: "Smith",
        email: "jane.smith@example.com",
        phone_number: "+44123456790",
        address_1: "456 Oak Avenue",
        town: "Manchester",
        postcode: "M1 1AA",
      },
      status: {
        id: 2,
        name: "Documents Required",
        color: "#ffc107",
      },
      status_id: 2,
      rents: [
        {
          id: 2,
          date_to_send_documentation: "2024-01-10T00:00:00.000Z",
          room: {
            id: 2,
            name: "Room 2",
            property: {
              id: 2,
              name: "18 White House",
            },
          },
        },
      ],
    },
    {
      id: 3,
      unique_guardian_number: "GG001236",
      user: {
        id: 3,
        first_name: "Michael",
        last_name: "Brown",
        email: "michael.brown@example.com",
        phone_number: "+44123456791",
        address_1: "789 Pine Street",
        town: "Birmingham",
        postcode: "B1 1AA",
      },
      status: {
        id: 2,
        name: "Documents Required",
        color: "#ffc107",
      },
      status_id: 2,
      rents: [
        {
          id: 3,
          date_to_send_documentation: "2024-01-05T00:00:00.000Z",
          room: {
            id: 3,
            name: "Flat 1",
            property: {
              id: 3,
              name: "Bedfont Community Centre",
            },
          },
        },
      ],
    },
    {
      id: 4,
      unique_guardian_number: "GG001237",
      user: {
        id: 4,
        first_name: "Sarah",
        last_name: "Wilson",
        email: "sarah.wilson@example.com",
        phone_number: "+44123456792",
        address_1: "321 Elm Street",
        town: "Leeds",
        postcode: "LS1 1AA",
      },
      status: {
        id: 2,
        name: "Documents Required",
        color: "#ffc107",
      },
      status_id: 2,
      rents: [
        {
          id: 4,
          date_to_send_documentation: "2024-01-01T00:00:00.000Z",
          room: {
            id: 4,
            name: "Room 8",
            property: {
              id: 4,
              name: "Victoria Business Centre",
            },
          },
        },
      ],
    },
    {
      id: 5,
      unique_guardian_number: "GG001238",
      user: {
        id: 5,
        first_name: "David",
        last_name: "Johnson",
        email: "david.johnson@example.com",
        phone_number: "+44123456793",
        address_1: "654 Maple Street",
        town: "Liverpool",
        postcode: "L1 1AA",
      },
      status: {
        id: 5,
        name: "Documents Required",
        color: "#ffc107",
      },
      rents: [
        {
          id: 5,
          date_to_send_documentation: "2023-12-25T00:00:00.000Z",
          room: {
            id: 5,
            name: "Room 3",
            property: {
              id: 5,
              name: "Central Business Park",
            },
          },
        },
      ],
    },
    {
      id: 6,
      unique_guardian_number: "GG001239",
      user: {
        id: 6,
        first_name: "Emma",
        last_name: "Davis",
        email: "emma.davis@example.com",
        phone_number: "+44123456794",
        address_1: "987 Cedar Lane",
        town: "Bristol",
        postcode: "BS1 1AA",
      },
      status: {
        id: 5,
        name: "Documents Required",
        color: "#ffc107",
      },
      rents: [
        {
          id: 6,
          date_to_send_documentation: "2023-12-20T00:00:00.000Z",
          room: {
            id: 6,
            name: "Room 4",
            property: {
              id: 6,
              name: "Harbour View Apartments",
            },
          },
        },
      ],
    },
    {
      id: 7,
      unique_guardian_number: "GG001240",
      user: {
        id: 7,
        first_name: "James",
        last_name: "Miller",
        email: "james.miller@example.com",
        phone_number: "+44123456795",
        address_1: "147 Birch Road",
        town: "Newcastle",
        postcode: "NE1 1AA",
      },
      status: {
        id: 5,
        name: "Documents Required",
        color: "#ffc107",
      },
      rents: [
        {
          id: 7,
          date_to_send_documentation: "2023-12-15T00:00:00.000Z",
          room: {
            id: 7,
            name: "Room 5",
            property: {
              id: 7,
              name: "Riverside Business Centre",
            },
          },
        },
      ],
    },
    {
      id: 8,
      unique_guardian_number: "GG001241",
      user: {
        id: 8,
        first_name: "Lisa",
        last_name: "Anderson",
        email: "lisa.anderson@example.com",
        phone_number: "+44123456796",
        address_1: "258 Willow Street",
        town: "Sheffield",
        postcode: "S1 1AA",
      },
      status: {
        id: 5,
        name: "Documents Required",
        color: "#ffc107",
      },
      rents: [
        {
          id: 8,
          date_to_send_documentation: "2023-12-10T00:00:00.000Z",
          room: {
            id: 8,
            name: "Room 6",
            property: {
              id: 8,
              name: "Steel City Offices",
            },
          },
        },
      ],
    },
    {
      id: 9,
      unique_guardian_number: "GG001242",
      user: {
        id: 9,
        first_name: "Robert",
        last_name: "Taylor",
        email: "robert.taylor@example.com",
        phone_number: "+44123456797",
        address_1: "369 Ash Avenue",
        town: "Cardiff",
        postcode: "CF1 1AA",
      },
      status: {
        id: 5,
        name: "Documents Required",
        color: "#ffc107",
      },
      rents: [
        {
          id: 9,
          date_to_send_documentation: "2023-12-05T00:00:00.000Z",
          room: {
            id: 9,
            name: "Room 7",
            property: {
              id: 9,
              name: "Bay View Complex",
            },
          },
        },
      ],
    },
    {
      id: 10,
      unique_guardian_number: "GG001243",
      user: {
        id: 10,
        first_name: "Amanda",
        last_name: "White",
        email: "amanda.white@example.com",
        phone_number: "+44123456798",
        address_1: "741 Poplar Drive",
        town: "Edinburgh",
        postcode: "EH1 1AA",
      },
      status: {
        id: 5,
        name: "Documents Required",
        color: "#ffc107",
      },
      rents: [
        {
          id: 10,
          date_to_send_documentation: "2023-11-30T00:00:00.000Z",
          room: {
            id: 10,
            name: "Room 9",
            property: {
              id: 10,
              name: "Castle View Business Park",
            },
          },
        },
      ],
    },
  ];
};

const guardiansService = {
  // Get all guardians with optional filters (CLIENT-SIDE PAGINATION - DEPRECATED)
  getGuardians: async (filters = {}) => {
    try {
      console.log("Fetching guardians with filters:", filters);
      const response = await api.get("/guardians", { params: filters });
      console.log("Guardians response:", response.data);
      // Handle both response formats (data or guardians)
      return response.data.guardians || response.data.data || [];
    } catch (error) {
      console.error("❌ Error fetching guardians:", error);
      throw error; // Throw error instead of returning mock data
    }
  },

  // Get guardians with server-side pagination (DataTables protocol)
  getGuardiansDataTable: async (datatableParams) => {
    try {
      console.log(
        "📊 [SERVICE] Fetching guardians with DataTables params:",
        datatableParams,
      );
      const response = await api.post("/guardians/datatable", datatableParams);
      console.log("✅ [SERVICE] Guardians DataTable response:", response.data);
      return response.data; // Returns { draw, data, recordsTotal, recordsFiltered }
    } catch (error) {
      console.error(
        "❌ [SERVICE] Error fetching guardians with pagination:",
        error,
      );
      throw error;
    }
  },

  // Get guardian by ID
  getGuardianById: async (guardianId) => {
    try {
      // Add cache-busting parameter to ensure fresh data
      const response = await api.get(
        `/guardians/${guardianId}?_t=${Date.now()}`,
      );
      return response.data.guardian;
    } catch (error) {
      console.error("❌ Error fetching guardian:", error);
      throw error; // Always throw error instead of returning mock data
    }
  },

  // Status update functions
  blacklistGuardian: async (guardianId) => {
    try {
      // Laravel: GET /guardians/{id}/blacklist
      const response = await api.get(`/guardians/${guardianId}/blacklist`);
      return response.data;
    } catch (error) {
      console.error("Error blacklisting guardian:", error);
      throw error;
    }
  },

  unblacklistGuardian: async (guardianId) => {
    try {
      // Laravel: GET /guardians/{id}/unblacklist
      const response = await api.get(`/guardians/${guardianId}/unblacklist`);
      return response.data;
    } catch (error) {
      console.error("Error unblacklisting guardian:", error);
      throw error;
    }
  },

  setAsRegistered: async (guardianId) => {
    try {
      const response = await api.get(
        `/guardians/${guardianId}/set-as-registered`,
      );
      return response.data;
    } catch (error) {
      console.error("Error setting guardian as registered:", error);
      throw error;
    }
  },

  assignGuardian: async (guardianId) => {
    try {
      const response = await api.put(`/guardians/${guardianId}/assign`);
      return response.data;
    } catch (error) {
      console.error("Error assigning guardian:", error);
      throw error;
    }
  },

  markNotInterested: async (guardianId) => {
    try {
      // Laravel: GET /property-application/guardian/{guardianId} (same as dismiss)
      const response = await api.get(
        `/property-application/guardian/${guardianId}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error marking guardian as not interested:", error);
      throw error;
    }
  },

  // Create a new guardian
  createGuardian: async (guardianData) => {
    try {
      // Transform guardian data to match user controller expectations
      const userData = {
        // Basic user fields
        email: guardianData.email,
        email_alternative: guardianData.email_alternative || null,
        password: guardianData.password,
        confirm_password: guardianData.password_confirmation,
        first_name: guardianData.first_name,
        last_name: guardianData.last_name,
        mobile_number: guardianData.mobile_number,
        phone_number: guardianData.phone_number,
        salutation: guardianData.salutation,
        job_title: guardianData.job_title,
        address_1: guardianData.address_1,
        address_2: guardianData.address_2,
        address_3: guardianData.address_3,
        town: guardianData.town,
        postcode: guardianData.postcode,
        fax_number: guardianData.fax_number || "",

        // Role specification
        role_id: 9, // Guardian role ID (updated from 3 to 9)

        // Guardian-specific fields
        gender: guardianData.gender,
        gender_freetext: guardianData.gender_freetext,
        date_of_birth: guardianData.date_of_birth,
        national_insurance_number: guardianData.national_insurance_number,
        country_id: guardianData.nationality_id,
        religion_id: guardianData.religion_id,
        hear_about_id: guardianData.hear_about_id,
        criminal_record: guardianData.criminal_record || 0,
        criminal_record_description: guardianData.criminal_record_description,
        medical_condition: guardianData.medical_condition || 0,
        medical_condition_description:
          guardianData.medical_condition_description,
        next_of_kin: guardianData.next_of_kin,

        // Staff-related fields
        staff: guardianData.staff || 0,
        staff_guardian_page: guardianData.staff_guardian_page || 0,
        staff_property_owners: guardianData.staff_property_owners || 0,
        staff_about_us_page: guardianData.staff_about_us_page || 0,
        department_id: null, // Guardians don't have departments
        biography: guardianData.biography,

        // Notification preferences
        rec_notif_of_property_status:
          guardianData.rec_notif_of_property_status || 0,
        rec_notif_of_property_id: guardianData.rec_notif_of_property_id || 0,

        // Image handling
        image: guardianData.image,
        imageKey: guardianData.imageKey,
        imageName: guardianData.imageName,
        imageType: guardianData.imageType,
        imageSize: guardianData.imageSize,

        // Additional fields
        color: guardianData.color || "#000000",
        verified: 1,
      };

      const response = await api.post("/users", userData);
      return response.data;
    } catch (error) {
      console.error("Error creating guardian:", error);
      throw error;
    }
  },

  // Update guardian
  updateGuardian: async (guardianId, updateData) => {
    try {
      const response = await api.put(`/guardians/${guardianId}`, updateData);
      return response.data;
    } catch (error) {
      console.error("Error updating guardian:", error);
      throw error;
    }
  },

  // Update a single field on a guardian (e.g. notes, on_newsletter_list)
  changeField: async (guardianId, field, value) => {
    try {
      const response = await api.post("/guardians/change-field", {
        guardianId,
        field,
        value,
      });
      return response.data;
    } catch (error) {
      console.error("Error changing guardian field:", error);
      throw error;
    }
  },

  // Update guardian profile (personal details, contact info, etc.)
  updateGuardianProfile: async (guardianId, profileData) => {
    try {
      const response = await api.put(
        `/guardians/${guardianId}/profile`,
        profileData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating guardian profile:", error);
      throw error;
    }
  },

  // Delete guardian
  deleteGuardian: async (guardianId) => {
    try {
      console.log("Service deleteGuardian called with ID:", guardianId);
      // Laravel equivalent: DELETE /guardians/{id}/destroy
      const response = await api.delete(`/guardians/${guardianId}/destroy`);
      return response.data;
    } catch (error) {
      console.error("Error deleting guardian:", error);
      throw error;
    }
  },

  // Get guardian statuses
  getGuardianStatuses: async () => {
    try {
      const response = await api.get("/guardians/statuses");
      return response.data.statuses || [];
    } catch (error) {
      console.error("Error fetching guardian statuses:", error);
      return [
        { id: 1, name: "Vetted", color: "#28a745" },
        { id: 2, name: "Documents Required", color: "#ffc107" },
        { id: 3, name: "Active", color: "#006cff" },
        { id: 4, name: "Inactive", color: "#6c757d" },
        { id: 5, name: "Blacklisted", color: "#dc3545" },
        { id: 6, name: "Finished", color: "#17a2b8" },
      ];
    }
  },

  // Get guardian status overview
  getGuardianStatusOverview: async () => {
    try {
      const response = await api.get("/guardians/status-overview");
      return response.data.overview || {};
    } catch (error) {
      console.error("Error fetching guardian status overview:", error);
      return {};
    }
  },

  // Export guardians to CSV - uses POST to support column visibility
  exportGuardiansCSV: async (filters = {}, visibleColumns = []) => {
    try {
      const response = await api.post(
        "/export/guardians/csv",
        {
          ...filters,
          visibleColumns,
        },
        {
          responseType: "blob",
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error exporting guardians CSV:", error);
      throw error;
    }
  },

  // Export guardians to Excel - uses POST to support column visibility
  exportGuardiansExcel: async (filters = {}, visibleColumns = []) => {
    try {
      const response = await api.post(
        "/export/guardians/excel",
        {
          ...filters,
          visibleColumns,
        },
        {
          responseType: "blob",
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error exporting guardians Excel:", error);
      throw error;
    }
  },

  // Export guardians to PDF
  exportGuardiansPDF: async (filters = {}) => {
    try {
      const response = await api.get("/export/guardians/pdf", {
        params: filters,
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      console.error("Error exporting guardians PDF:", error);
      throw error;
    }
  },

  // Get locations
  getLocations: async () => {
    try {
      const response = await api.get("/guardians/locations");
      return response.data.locations || [];
    } catch (error) {
      console.error("Error fetching locations:", error);
      return [
        { id: 1, name: "London" },
        { id: 2, name: "Manchester" },
        { id: 3, name: "Birmingham" },
        { id: 4, name: "Liverpool" },
        { id: 5, name: "Leeds" },
      ];
    }
  },

  // Registration sources (trackable link each guardian registered through).
  // Returns { sources, total } - total drives the filter's "All" option.
  getRegistrationSources: async () => {
    try {
      const response = await api.get("/guardians/registration-sources");
      return {
        sources: response.data.sources || [],
        total: response.data.total || 0,
      };
    } catch (error) {
      console.error("Error fetching registration sources:", error);
      return { sources: [], total: 0 };
    }
  },

  // Get dropdown data
  getDropdownData: async () => {
    try {
      const response = await api.get("/guardians/dropdown-data");
      return response.data;
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
      return {
        statuses: [],
        locations: [],
        nationalities: [],
        religions: [],
        hearAbouts: [],
      };
    }
  },

  // Feature-specific functions
  getGuardiansAfterEnd: async () => {
    try {
      const response = await api.get("/guardians/after-end");
      return response.data.guardians || [];
    } catch (error) {
      console.error("Error fetching guardians after end:", error);
      return [];
    }
  },

  updateGuardianDates: async (guardianId, dateData) => {
    try {
      const response = await api.put(
        `/guardians/${guardianId}/dates`,
        dateData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating guardian dates:", error);
      throw error;
    }
  },

  finishGuardianship: async (guardianId) => {
    try {
      const response = await api.put(`/guardians/${guardianId}/finish`);
      return response.data;
    } catch (error) {
      console.error("Error finishing guardianship:", error);
      throw error;
    }
  },

  updateGuardianRent: async (guardianId, rentData) => {
    try {
      const response = await api.put(`/guardians/${guardianId}/rent`, rentData);
      return response.data;
    } catch (error) {
      console.error("Error updating guardian rent:", error);
      throw error;
    }
  },

  assignManagingOfficer: async (guardianId, officerId) => {
    try {
      const response = await api.put(
        `/guardians/${guardianId}/assign-officer`,
        { officer_id: officerId },
      );
      return response.data;
    } catch (error) {
      console.error("Error assigning managing officer:", error);
      throw error;
    }
  },

  getGuardianPayments: async (guardianId) => {
    try {
      const response = await api.get(`/guardians/${guardianId}/payments`);
      return response.data.payments || [];
    } catch (error) {
      console.error("Error fetching guardian payments:", error);
      return [];
    }
  },

  addGuardianPayment: async (guardianId, paymentData) => {
    try {
      const response = await api.post(
        `/guardians/${guardianId}/payments`,
        paymentData,
      );
      return response.data;
    } catch (error) {
      console.error("Error adding guardian payment:", error);
      throw error;
    }
  },

  updateGuardianPayment: async (paymentId, updateData) => {
    try {
      const response = await api.put(
        `/guardians/payments/${paymentId}`,
        updateData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating guardian payment:", error);
      throw error;
    }
  },

  sendNoticeToQuit: async (guardianId, ntqData) => {
    try {
      const response = await api.post(
        `/guardians/${guardianId}/notice-to-quit`,
        ntqData,
      );
      return response.data;
    } catch (error) {
      console.error("Error sending notice to quit:", error);
      throw error;
    }
  },

  getGuardianRents: async (guardianId) => {
    try {
      const response = await api.get(`/guardians/${guardianId}/rents`);
      return response.data.rents || [];
    } catch (error) {
      console.error("Error fetching guardian rents:", error);
      return [];
    }
  },

  getCouplesList: async () => {
    try {
      const response = await api.get("/guardians/couples");
      return response.data.couples || [];
    } catch (error) {
      console.error("Error fetching couples list:", error);
      return [];
    }
  },

  getHearAbouts: async () => {
    try {
      const response = await api.get("/guardians/hear-about");
      return response.data.hearAbouts || [];
    } catch (error) {
      console.error("Error fetching hear abouts:", error);
      return [];
    }
  },

  createHearAbout: async (hearAboutData) => {
    try {
      const response = await api.post("/guardians/hear-about", hearAboutData);
      return response.data;
    } catch (error) {
      console.error("Error creating hear about category:", error);
      throw error;
    }
  },

  updateHearAbout: async (id, hearAboutData) => {
    try {
      const response = await api.put(
        `/guardians/hear-about/${id}`,
        hearAboutData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating hear about:", error);
      throw error;
    }
  },

  deleteHearAbout: async (id) => {
    try {
      const response = await api.delete(`/guardians/hear-about/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting hear about:", error);
      throw error;
    }
  },

  getGuardiansAfterDeadline: async () => {
    try {
      // For now, force mock data to test the UI
      console.log("Forcing mock data for testing");
      return getMockAfterDeadlineGuardians();

      // Uncomment below when backend is running
      /*
      const response = await api.get("/guardians/after-deadline");
      if (response.data.success) {
        return response.data.guardians || [];
      } else {
        console.warn("API returned success: false:", response.data.message);
        return getMockAfterDeadlineGuardians();
      }
      */
    } catch (error) {
      console.error("Error fetching guardians after deadline:", error);
      if (error.response) {
        // Server responded with error status
        if (error.response.status === 404) {
          console.warn(
            "Guardians after deadline endpoint not found (404) - returning mock data",
          );
          return getMockAfterDeadlineGuardians();
        }
        console.warn(
          `Server error: ${error.response.status} - ${
            error.response.data?.message || "Unknown error"
          }`,
        );
        return getMockAfterDeadlineGuardians();
      } else if (error.request) {
        // Network error
        console.warn(
          "Network error: Unable to connect to server - returning mock data",
        );
        return getMockAfterDeadlineGuardians();
      } else {
        // Other error
        console.warn("Other error:", error.message);
        return getMockAfterDeadlineGuardians();
      }
    }
  },

  getGuardianComplaints: async () => {
    try {
      const response = await api.get("/guardians/complaints");
      return response.data.complaints || [];
    } catch (error) {
      console.error("Error fetching guardian complaints:", error);
      return [];
    }
  },

  updateGuardianComplaint: async (complaintId, updateData) => {
    try {
      const response = await api.put(
        `/guardians/complaints/${complaintId}`,
        updateData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating guardian complaint:", error);
      throw error;
    }
  },

  getGuardianQueries: async () => {
    try {
      const response = await api.get("/guardians/queries");
      return response.data.queries || [];
    } catch (error) {
      console.error("Error fetching guardian queries:", error);
      return [];
    }
  },

  replyToGuardianQuery: async (queryId, replyData) => {
    try {
      const response = await api.post(
        `/guardians/queries/${queryId}/reply`,
        replyData,
      );
      return response.data;
    } catch (error) {
      console.error("Error replying to guardian query:", error);
      throw error;
    }
  },

  // Missing service methods for action buttons
  declineDocumentation: async (guardianId, reason) => {
    try {
      // Laravel: POST /property-application/decline-documentation/{guardianId}/confirm
      const response = await api.post(
        `/property-application/decline-documentation/${guardianId}/confirm`,
        { reason },
      );
      return response.data;
    } catch (error) {
      console.error("Error declining documentation:", error);
      throw error;
    }
  },

  dismissFromProperty: async (rentId) => {
    try {
      const response = await api.put(`/rents/${rentId}/dismiss`);
      return response.data;
    } catch (error) {
      console.error("Error dismissing from property:", error);
      throw error;
    }
  },

  markAsNotInterested: async (guardianId) => {
    try {
      // Laravel equivalent: GET /property-application/guardian/{guardianId}
      const response = await api.get(`/guardians/${guardianId}/not-interested`);
      return response.data;
    } catch (error) {
      console.error("Error marking as not interested:", error);
      throw error;
    }
  },

  markInitialPaymentAsPaid: async (rentId) => {
    try {
      const response = await api.put(`/rents/${rentId}/mark-paid`);
      return response.data;
    } catch (error) {
      console.error("Error marking payment as paid:", error);
      throw error;
    }
  },

  signLicenseAgreement: async (rentId) => {
    try {
      const response = await api.put(`/rents/${rentId}/sign-agreement`);
      return response.data;
    } catch (error) {
      console.error("Error signing license agreement:", error);
      throw error;
    }
  },

  startRent: async (rentId) => {
    try {
      const response = await api.post(`/rents/${rentId}/start`);
      return response.data;
    } catch (error) {
      console.error("Error starting rent:", error);
      throw error;
    }
  },

  declineGuardian: async (guardianId) => {
    try {
      const response = await api.put(`/guardians/${guardianId}/decline`);
      return response.data;
    } catch (error) {
      console.error("Error declining guardian:", error);
      throw error;
    }
  },

  archiveGuardian: async (guardianId) => {
    try {
      // Laravel: POST /guardians/{id}/archive
      const response = await api.post(`/guardians/${guardianId}/archive`);
      return response.data;
    } catch (error) {
      console.error("Error archiving guardian:", error);
      throw error;
    }
  },

  sendPaymentDetails: async (guardianId) => {
    try {
      // Laravel: GET /guardians/{id}/send-reminders/payment-details
      const response = await api.get(
        `/guardians/${guardianId}/send-reminders/payment-details`,
      );
      return response.data;
    } catch (error) {
      console.error("Error sending payment details:", error);
      throw error;
    }
  },

  sendPaymentReminder: async (guardianId) => {
    try {
      // Laravel: GET /guardians/{id}/send-reminders/payment-reminder
      const response = await api.get(
        `/guardians/${guardianId}/send-reminders/payment-reminder`,
      );
      return response.data;
    } catch (error) {
      console.error("Error sending payment reminder:", error);
      throw error;
    }
  },

  setToDocumentsRequired: async (guardianId) => {
    try {
      const response = await api.put(
        `/guardians/${guardianId}/set-to-documents-required`,
      );
      return response.data;
    } catch (error) {
      console.error("Error setting to documents required:", error);
      throw error;
    }
  },

  // New Action Button Methods
  showGuardian: async (guardianId) => {
    try {
      const response = await api.get(`/guardians/${guardianId}/show`);
      return response.data;
    } catch (error) {
      console.error("Error showing guardian:", error);
      throw error;
    }
  },

  editGuardian: async (guardianId) => {
    try {
      const response = await api.get(`/guardians/${guardianId}/edit`);
      return response.data;
    } catch (error) {
      console.error("Error getting guardian edit data:", error);
      throw error;
    }
  },

  // Laravel: Two separate endpoints for dismiss functionality
  dismissFromRent: async (rentId) => {
    try {
      // Laravel: GET /property-application/rent/{rentId}
      const response = await api.get(`/property-application/rent/${rentId}`);
      return response.data;
    } catch (error) {
      console.error("Error dismissing from rent:", error);
      throw error;
    }
  },

  dismissGuardian: async (guardianId) => {
    try {
      // Laravel: GET /property-application/guardian/{guardianId}
      const response = await api.get(
        `/property-application/guardian/${guardianId}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error dismissing guardian:", error);
      throw error;
    }
  },

  // Payment Workflow Methods
  markAsPaid: async (rentId, paymentId = null) => {
    try {
      // Laravel equivalent: GET /payments/mark-as-paid-initial/{rentId}/{paymentId?}
      const url = paymentId
        ? `/payments/mark-as-paid-initial/${rentId}/${paymentId}`
        : `/payments/mark-as-paid-initial/${rentId}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error("Error marking payment as paid:", error);
      throw error;
    }
  },

  setPayment: async (roomId, paymentData) => {
    try {
      const response = await api.post(
        `/guardians/rooms/${roomId}/set-payment`,
        paymentData,
      );
      return response.data;
    } catch (error) {
      console.error("Error setting payment:", error);
      throw error;
    }
  },

  // Rent Workflow Methods
  signAgreement: async (rentId, agreementData) => {
    try {
      // Align with backend route used by signLicenseAgreement
      const response = await api.put(
        `/rents/${rentId}/sign-agreement`,
        agreementData,
      );
      return response.data;
    } catch (error) {
      console.error("Error signing agreement:", error);
      throw error;
    }
  },

  changeRent: async (roomId, rentData) => {
    try {
      const response = await api.put(
        `/guardians/rooms/${roomId}/change-rent`,
        rentData,
      );
      return response.data;
    } catch (error) {
      console.error("Error changing rent:", error);
      throw error;
    }
  },

  // Additional Status Methods
  updateDates: async (guardianId, dateData) => {
    try {
      const response = await api.put(
        `/guardians/${guardianId}/update-dates`,
        dateData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating guardian dates:", error);
      throw error;
    }
  },

  moveGuardian: async (guardianId, moveData) => {
    try {
      const response = await api.put(`/guardians/${guardianId}/move`, moveData);
      return response.data;
    } catch (error) {
      console.error("Error moving guardian:", error);
      throw error;
    }
  },

  // Additional Cross Navigation Methods
  downloadGuardianDetails: async (guardianId) => {
    try {
      const response = await api.post(
        `/guardians/${guardianId}/details`,
        {},
        {
          responseType: "blob", // For file download
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error downloading guardian details:", error);
      throw error;
    }
  },

  // Print labels for guardians
  printLabels: async (filters = {}) => {
    try {
      const response = await api.get("/guardians/print-labels", {
        params: filters,
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      console.error("❌ Error printing labels:", error);
      throw error;
    }
  },

  // Download statement for guardians
  downloadStatement: async (filters = {}) => {
    try {
      const response = await api.get("/guardians/download-statement", {
        params: filters,
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      console.error("❌ Error downloading statement:", error);
      throw error;
    }
  },

  // Document management methods
  uploadDocument: async (guardianId, file, documentType) => {
    try {
      const formData = new FormData();
      formData.append("document", file);
      formData.append("documentType", documentType);
      formData.append("guardianId", guardianId);

      const response = await api.post(
        `/guardians/stage-1-documents/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error uploading document:", error);
      throw error;
    }
  },

  deleteDocument: async (documentId) => {
    try {
      const response = await api.delete(`/documents/${documentId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting document:", error);
      throw error;
    }
  },

  getDocument: async (documentId) => {
    try {
      const response = await api.get(`/documents/${documentId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching document:", error);
      throw error;
    }
  },

  // Employment history methods
  deleteEmploymentHistory: async (historyId) => {
    try {
      const response = await api.delete(`/employmenthistory/${historyId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting employment history:", error);
      throw error;
    }
  },

  // Upload documents
  uploadDocuments: async (guardianId, formData) => {
    try {
      const response = await api.post(
        `/guardians/documents/${guardianId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error uploading documents:", error);
      throw error;
    }
  },

  // Decline documentation confirmation
  declineDocumentationConfirm: async (guardianId, reason) => {
    try {
      const response = await api.post(
        `/property-application/decline-documentation/${guardianId}/confirm`,
        {
          reason: reason,
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error declining documentation:", error);
      throw error;
    }
  },

  // Get guardians in process for SALES WITH GUARDIANS dashboard
  getGuardiansInProcess: async () => {
    try {
      const response = await api.get("/guardians/in-process");
      console.log(
        "✅ [SERVICE] Guardians in process loaded from API:",
        response.data,
      );
      return response.data;
    } catch (error) {
      console.error("❌ [SERVICE] Error fetching guardians in process:", error);
      throw error; // Throw error instead of returning mock data
    }
  },

  // Get complete Sales With Guardians dashboard data (guardians, viewings, statuses, etc.)
  getSalesWithGuardiansDashboard: async () => {
    try {
      const response = await api.get("/dashboard/sales-with-guardians");
      console.log(
        "✅ [SERVICE] Sales dashboard data loaded from API:",
        response.data,
      );
      return response.data;
    } catch (error) {
      console.error("❌ [SERVICE] Error fetching sales dashboard data:", error);
      throw error;
    }
  },

  // Approve documents - Laravel: POST /property-application/approved-documentation/{guardianId}
  approveDocuments: async (guardianId) => {
    try {
      const response = await api.post(
        `/property-application/approved-documentation/${guardianId}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error approving documents:", error);
      throw error;
    }
  },

  // Decline application - Laravel: POST /property-application/decline-profile/{guardianId}
  declineApplication: async (guardianId) => {
    try {
      const response = await api.post(
        `/property-application/decline-profile/${guardianId}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error declining application:", error);
      throw error;
    }
  },

  // Generate presigned URLs for document uploads
  generatePresignedUrls: async (guardianId, files) => {
    try {
      const response = await api.post(
        `/guardians/documents/${guardianId}/presigned-urls`,
        { files },
      );
      return response.data;
    } catch (error) {
      console.error("Error generating presigned URLs:", error);
      throw error;
    }
  },

  // Upload file directly to S3 using presigned URL
  // Note: Do NOT set Content-Type header - it's already included in the presigned URL
  uploadFileToS3: async (presignedUrl, file) => {
    try {
      const response = await fetch(presignedUrl, {
        method: "PUT",
        body: file,
        // Do NOT set Content-Type - it's already included in the presigned URL signature
      });

      if (!response.ok) {
        throw new Error(
          `S3 upload failed: ${response.status} ${response.statusText}`,
        );
      }

      return { success: true };
    } catch (error) {
      console.error("Error uploading file to S3:", error);
      throw error;
    }
  },

  // Confirm document upload after S3 upload completes
  confirmDocumentUpload: async (guardianId, uploads) => {
    try {
      const response = await api.post(
        `/guardians/documents/${guardianId}/confirm-upload`,
        { uploads },
      );
      return response.data;
    } catch (error) {
      console.error("Error confirming document upload:", error);
      throw error;
    }
  },

  // Download guardian document (uses S3 presigned URLs - matching Laravel)
  downloadGuardianDocument: async (guardianId, documentId) => {
    try {
      // Get presigned URL from backend (JSON response, not blob)
      const response = await api.get(
        `/guardians/${guardianId}/documents/${documentId}/download`,
      );

      if (!response.data.success || !response.data.data.presignedUrl) {
        throw new Error(response.data.message || "Failed to get presigned URL");
      }

      // Use presigned URL directly for download (matching Laravel's direct S3 access)
      const presignedUrl = response.data.data.presignedUrl;
      const filename =
        response.data.data.documentName || `document_${documentId}.pdf`;

      console.log(`✅ Using presigned URL for direct S3 download: ${filename}`);

      // Create download link with presigned URL
      const a = document.createElement("a");
      a.href = presignedUrl;
      a.download = filename;
      a.target = "_blank"; // Open in new tab for direct S3 access
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      return {
        success: true,
        message: "Document downloaded successfully",
      };
    } catch (error) {
      console.error("Error downloading guardian document:", error);
      throw error;
    }
  },

  // Delete guardian document
  deleteGuardianDocument: async (guardianId, documentId) => {
    try {
      console.log(
        `🗑️ [SERVICE] Deleting document: guardianId=${guardianId}, documentId=${documentId}`,
      );
      const response = await api.delete(
        `/guardians/${guardianId}/documents/${documentId}`,
      );
      console.log("✅ [SERVICE] Delete response:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ [SERVICE] Error deleting guardian document:", error);
      console.error("❌ [SERVICE] Error response:", error.response?.data);
      throw error;
    }
  },
};

export default guardiansService;
